import { DialogProvider, InfoDialogOptions, InfoDialogState, useDialog } from "./DialogContext";

export type { InfoDialogOptions, InfoDialogState };

export const InfoDialogProvider = DialogProvider;

export function useInfoDialog() {
    const { showInfo, pending, handleClose } = useDialog();

    return {
        showInfo,
        pending: pending?.variant === "info" ? pending as InfoDialogState : null,
        handleClose,
    };
}
